<div class="wrapper">
    <div class="container">
        <div class="item-list">
            <search-item *ngFor="let item of items" [item]="item"></search-item>
        </div>
    </div>
</div>